import React from 'react';

type Status = 'ok' | 'ng' | 'warning' | 'neutral';

const ICONS: Record<Status, React.ReactNode> = {
  ok: (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
  ng: (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" aria-hidden="true">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  warning: (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  neutral: (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" aria-hidden="true">
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  ),
};

const CLASSES: Record<Status, string> = {
  ok: 'badge-success',
  ng: 'badge-danger',
  warning: 'badge-warning',
  neutral: 'badge-neutral',
};

interface StatusChipProps {
  status: Status;
  children: React.ReactNode;
  className?: string;
}

/**
 * Status is always conveyed by icon + label, never by colour alone — the
 * warning/serious status colours sit below 3:1 on a light surface by design.
 */
export function StatusChip({ status, children, className = '' }: StatusChipProps) {
  return (
    <span className={`badge ${CLASSES[status]} ${className}`}>
      {ICONS[status]}
      <span>{children}</span>
    </span>
  );
}
